/**
 * Created by piotr.pozniak@thebeaverhead.com on 16/07/2025.
 */
import { useEffect, useRef, useState } from "react";

export function useScrollHeightObserver() {
  const ref = useRef(null);
  const [scrollHeight, setScrollHeight] = useState(0);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const updateHeight = () => {
      setScrollHeight(element.scrollHeight);
    };

    const mutationObserver = new MutationObserver(updateHeight);
    mutationObserver.observe(element, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(element);

    // Initial call
    updateHeight();

    return () => {
      mutationObserver.disconnect();
      resizeObserver.disconnect();
    };
  }, []);

  return [ref, scrollHeight];
}
